import axios from 'axios';
import {Loading, Message} from 'element-ui';

const RetState = {
  SUCCESS: {ec: '0', msg: '成功'},
  FAIL: {ec: '1', msg: '未登录'},
  NO_PERMISSION: {ec: '2', msg: '登录失效'},
};
const loading = (function loading() {
  let IndicatorCount = 0;
  let loadingInstance;
  return {
    show: () => {
      if (IndicatorCount === 0) {
        loadingInstance = Loading.service({
          fullscreen: true,
          lock: true,
          text: 'Loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
      }
      IndicatorCount += 1;
    },
    hide: () => {
      IndicatorCount -= 1;
      if (IndicatorCount === 0) {
        loadingInstance.close();
      }
    },
  };
}());
axios.interceptors.request.use((config) => {
  // eslint-disable-next-line no-param-reassign
  config.url = '/api/pof'+config.url
  config.hideload = config.hideload || false;
  if (!config.hideload) {
    loading.show();
  }
  return config;
});
axios.interceptors.response.use((response) => {
  if (!response.config.hideload) loading.hide();
  switch (response.data.code) {
    case RetState.SUCCESS.ec:
      break;
    case RetState.FAIL.ec:
      window.location.reload()
      break;
    case RetState.NO_PERMISSION.ec:
      window.location.href=window.location.pathname+'#/'
      break;
    default:
      Message({
        message: response.data.msg,
        type: 'warning',
        duration: 3000
      })
  }
  return response
},(error)=> {
  loading.hide();
  Message({
    message: error,
    type: 'error',
    duration: 3000
  });
})
export default axios



// WEBPACK FOOTER //
// ./src/fetch/ajax.js